/*
 *
 * VerifyPOSModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
 */
import React from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import PropTypes from 'prop-types'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from './languageModule'
import PortalButton from '@nexidigital/portalbutton'
import { openUrl } from 'Utility/globalMethods'

const VerifyPOSModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      customAnalyticsDescription={formattedMessage.introText}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
          </div>
        </div>
        <MerchantGenericCard empty>
          <p>
            {formattedMessage.introText}
          </p>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise1Title}
            </h1>
            <p>
              {formattedMessage.advise1Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise2Title}
            </h1>
            <p>
              {formattedMessage.advise2Text}
              <PortalButton
                textButton
                size='small'
                label={formattedMessage.linkLabel}
                onClick={() => { openUrl('https://www.pcisecuritystandards.org/documents/Skimming_Prevention_At-a-Glance_Sept2014.pdf', true) }}
              />
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise3Title}
            </h1>
            <p>
              {formattedMessage.advise3Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise4Title}
            </h1>
            <p>
              {formattedMessage.advise4Text}
              <ul>
                <li>{formattedMessage.advise4Item1}</li>
                <li>{formattedMessage.advise4Item2}</li>
                <li>{formattedMessage.advise4Item3}</li>
              </ul>
            </p>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

VerifyPOSModal.propTypes = {
  actions: PropTypes.object
}

VerifyPOSModal.defaultProps = {
  action: {}
}

export default VerifyPOSModal
